
import { useState } from 'react';

export default function CustomMetricForm() {
    const [metricName, setMetricName] = useState('');
    const [labels, setLabels] = useState([{ label: '', value: '' }]);
    const [timestamp, setTimestamp] = useState('');
    const [isBinary, setIsBinary] = useState(false);
    const [date, setDate] = useState('');
    const [error, setError] = useState('');

    function handleMetricNameChange(e) {
        setMetricName(e.target.value);
    }

    function handleLabelChange(index, e) {
        const updatedLabels = labels.map((item, i) =>
            index === i
                ? { ...item, [e.target.name]: e.target.value }
                : item
        );
        setLabels(updatedLabels);
    }

    function handleAddLabel() {
        setLabels([...labels, { label: '', value: '' }]);
    }

    function handleRemoveLabel(index) {
        const newLabels = [...labels];
        newLabels.splice(index, 1);
        setLabels(newLabels);
    }

    function handleTimestampChange(e) {
        setTimestamp(e.target.value);
    }

    function handleDateChange(e) {
        setDate(e.target.value);
    }

    function handleBinaryChange(e) {
        setIsBinary(e.target.checked);
        setError('');
    }

    function resetForm() {
        setMetricName('');
        setLabels([{ label: '', value: '' }]);
        setTimestamp('');
        setDate('');
    }

    async function handleSubmit() {
        setError('');
        if (!metricName) {
            setError('Metric name is required.');
            return;
        }

        const filledLabels = labels.filter((item) => item.label && item.value);
        if (labels.some((item) => Boolean(item.label) !== Boolean(item.value))) {
            setError('Each label needs both a name and a value.');
            return;
        }
        if (!isBinary && filledLabels.length === 0) {
            setError('Add at least one label, or mark this as a binary metric.');
            return;
        }
        if (isBinary && !date) {
            setError('Pick a date for this binary metric.');
            return;
        }

        const body = { metricName, labels: filledLabels };
        if (isBinary) {
            body.binary = true;
            body.date = date;
        } else {
            body.timestamp = timestamp ? new Date(parseInt(timestamp)).getTime() : Date.now();
        }

        const req = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            },
        };

        try {
            const res = await fetch('https://life.pmusgrave.dev/custom-metric', req);
            if (!res || res.status < 200 || res.status >= 300) {
                setError(`Submission failed (${res && res.status}). Nothing was recorded.`);
                return;
            }
        } catch (err) {
            setError(`Submission failed: ${err.message}. Nothing was recorded.`);
            return;
        }
        resetForm();
    }

    return (
        <div className="form-container">
            <h2>Custom Metric Form</h2>
            <form onSubmit={e => e.preventDefault()}>
                <div className="form-group">
                    <label htmlFor="metricName">Metric Name:</label>
                    <input
                        id="metricName"
                        type="text"
                        value={metricName}
                        onChange={handleMetricNameChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="isBinary">
                        <input
                            id="isBinary"
                            type="checkbox"
                            checked={isBinary}
                            onChange={handleBinaryChange}
                        />
                        Binary metric (did this happen on a given day?)
                    </label>
                </div>
                {labels.map((label, index) => (
                    <div key={index} className="form-group form-row">
                        <input
                            type="text"
                            name="label"
                            placeholder="Label (e.g., type, category)"
                            value={label.label}
                            onChange={(e) => handleLabelChange(index, e)}
                        />
                        <input
                            type="text"
                            name="value"
                            placeholder="Value (e.g., exercise, work)"
                            value={label.value}
                            onChange={(e) => handleLabelChange(index, e)}
                        />
                        <button
                            type="button"
                            onClick={() => handleRemoveLabel(index)}
                            className="remove-button"
                            title="Remove label"
                        >
                            &times;
                        </button>
                    </div>
                ))}
                <button
                    type="button"
                    onClick={handleAddLabel}
                    className="add-button"
                >
                    Add Label
                </button>
                {isBinary ? (
                    <div className="form-group">
                        <label htmlFor="date">Date:</label>
                        <input
                            id="date"
                            type="date"
                            value={date}
                            onChange={handleDateChange}
                            required
                        />
                    </div>
                ) : (
                    <div className="form-group">
                        <label htmlFor="timestamp">Timestamp (optional):</label>
                        <input
                            id="timestamp"
                            type="number"
                            value={timestamp}
                            onChange={handleTimestampChange}
                            placeholder="Unix timestamp"
                        />
                    </div>
                )}
                {error && <div className="form-error" role="alert">{error}</div>}
                <button
                    onClick={handleSubmit}
                    className="submit-button"
                >
                    Submit
                </button>
            </form>
        </div>
    );
}
